import { clsx } from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import React, { ReactElement } from 'react';
import classes from './MegaMenu.module.scss';

export type CategoryOption = {
  name: string;
  tag: string;
  count?: number;
};

export type Props = {
  categories: CategoryOption[];
  selectedCategory?: string;
  onCategorySelect: (tag: string) => void;
  className?: string;
};

function MegaMenu({
  categories,
  selectedCategory,
  onCategorySelect,
  className,
}: Readonly<Props>): ReactElement {
  return (
    <div className={clsx(classes.root, className)} role="menu">
      <div className={classes.categoryGrid}>
        {categories.map((category) => (
          <button
            key={category.tag}
            className={clsx(
              classes.categoryItem,
              selectedCategory === category.tag && classes.active,
              (category.count ?? 0) === 0 && classes.disabled,
            )}
            disabled={!category.count}
            onClick={() => onCategorySelect(category.tag)}
            role="menuitem"
          >
            <Txt className={classes.categoryName} skipTranslation>
              {category.name}
            </Txt>
            <span className={clsx(classes.categoryCount, !category.count && classes.disabled)}>
              {' '}
              ({category.count ?? 0})
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default MegaMenu;
